import { useMemo } from "react";
import { IOption } from "../../../../../types/Option";
import { Row, Select } from "antd";
import dayjs from "dayjs";

type YearSelectorProps = {
  value: string;
  onSelect: (val: string) => void;
};

export const YearSelector = ({ value, onSelect }: YearSelectorProps) => {
  const currentYear = useMemo(() => dayjs().year(), []);

  const options: IOption[] = useMemo(() => {
    let startYear: number = 2024;

    const availableYears: number[] = [];

    while (startYear !== currentYear) {
      availableYears.push(startYear);
      startYear++;
    }

    const res: IOption[] = availableYears.map((year: number) => ({
      value: `${year}-12-31`,
      label: year.toString(),
    }));

    return res;
  }, [currentYear]);

  return (
    <Row className="align-center">
      <span className="text-md mr-2">{currentYear} vs</span>
      <Select
        size="small"
        className="years-selector"
        options={options}
        value={value}
        onSelect={onSelect}
      />
    </Row>
  );
};
